import {
  API_KEY,
} from '@/config/google-maps.config';
import GoogleMapsApiLoader from 'google-maps-api-loader';

async function retrieveGoogleMapsApi() {
  const api = await GoogleMapsApiLoader({
    apiKey: API_KEY,
  });

  return api;
}

export default {
  getGoogleMapsApi: () => {
    const api = retrieveGoogleMapsApi();

    return api;
  },
};
